<template>
  <div class="pagination">
    <ul style="display:flex; list-style:none;">
      <li
        v-for="page in getPages"
        :key="page"
        :class="{selected: page === selectedPage}"
        @click="onPageSelect(page)"
      >{{page}}</li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: "Pagination",

    props: {
      currentPage: {
        required: false
      },

      totalPages: {
        required: false
      }
  },

  data() {
    return {
      selectedPage: 1
    };
  },
  watch: {
    currentPage() {
      this.selectedPage = this.currentPage;
    }
  },
  mounted() {},
  computed: {
    getPages() {
      let pages = [];
      if (isNaN(this.totalPages)) {
        return pages;
      }

      if (this.totalPages < 2) {
        return pages;
      }

      if (this.totalPages < 9) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
        return pages;
      }

      if (this.currentPage === 1) {
        pages.push(this.currentPage);
        pages.push(this.currentPage + 1);
        pages.push("...");
        pages.push(this.totalPages);
        pages.push(">");
      } else if (this.currentPage === this.totalPages) {
        pages.push("<");
        pages.push(1);
        pages.push("...");
        pages.push(this.currentPage - 1);
        pages.push(this.currentPage);
      } else {
        pages.push("<");
        if (this.currentPage > 2) {
          pages.push(1);
          pages.push(".,.");
        }
        pages.push(this.currentPage - 1);
        pages.push(this.currentPage);
        pages.push(this.currentPage + 1);
        if (this.currentPage < this.totalPages - 1) {
          pages.push("...");
          pages.push(this.totalPages);
        }
        pages.push(">");
        // pages = this.generatePages(this.currentPage, this.totalPages);
      }

      return pages;
    }
  },

  methods: {
    onPageSelect(page) {
      // console.log("onPageSelect", "before", page);

      switch (page) {
        case "<":
          page = this.currentPage - 1;
          break;
        case ">":
          page = this.currentPage + 1;
          break;
      }

      page = parseInt(page, 10);

      if (isNaN(page)) {
        return;
      }

      // console.log("onPageSelect", "after", page);
      this.selectedPage = page;
      this.$emit("onPageSelect", page);
    },

    generatePages(currentPage, totalPages) {
      let wingSize = 2;
      let pages = [];

      let start = currentPage - wingSize + 1;
      let stop = currentPage + wingSize;

      if (totalPages < 8) {
        start = 1;
        stop = totalPages + 1;
      } else if (currentPage < wingSize) {
        start = 1;
        stop = wingSize * 2;
      } else if (currentPage === totalPages) {
        start = totalPages - wingSize * 2;
        stop = totalPages + 1;
      } else if (currentPage > totalPages - wingSize) {
        stop = totalPages;
      }

      for (let i = start; i < stop; i++) {
        pages.push(i);
      }

      return pages;
    }
  }
};
</script>

<style scoped>
.pagination{
    float:left;
    margin-top: 10px;
    margin-bottom: 10px;    
}

.pagination li{
        float:left;
        cursor:pointer;
        list-style-type: none;
        width: 25px;
        height:25px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 15px;
        margin-right: 10px;
        border-radius: 50%;
        text-align: center;
        padding: 5px 0 0 0;        
    }

.pagination li .leftArrow, .rightArrow {
            display:inline-block;
            margin-bottom: 0px;
            width: 0;
            height: 0;
            border-top: 3px solid transparent;
            border-bottom: 3px solid transparent;
            border-right:3px solid #fff;
        }
        .rightArrow{
            border-right: 0;
            border-left: 3px solid #fff;
        }
</style>
